export const SHOW_CONFIRMATION_MODAL = 'SHOW_CONFIRMATION_MODAL';
export const CONFIRM_DIALOG = 'CONFIRM_DIALOG';
export const DENY_DIALOG = 'DENY_DIALOG';
export const HIDE_CONFIRMATION_MODAL = 'HIDE_CONFIRMATION_MODAL';